import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div data-testid="not-found-page" className="min-h-screen flex items-center justify-center bg-[#050505] pt-24 pb-16 px-6">
      <div className="text-center max-w-md">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-[#666] mb-5">404</p>
        <h1 className="font-display text-4xl sm:text-5xl text-white leading-[1.05] mb-5">
          Diese Seite gibt es nicht.
        </h1>
        <p className="text-[#999] mb-8 leading-relaxed">
          Der Link ist entweder falsch oder die Seite ist aktuell nicht verfügbar.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-flex items-center gap-2 rounded-full bg-white text-[#050505] px-6 py-3 text-sm font-medium hover:bg-[#d1d5db] transition-colors duration-300"
        >
          Zur Startseite
        </Link>
      </div>
    </div>
  );
}
